import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Layout,
  Input,
  Button,
  Divider,
  Table,
  MenuProps,
  Dropdown,
  Modal,
  Checkbox,
  Form,
  Select,
  Card,
} from "antd";
import {
  getMetalsService,
  getInventoryService,
  putRezeroInventoryService,
  putUpdateInventoryService,
  putMoveInventoryService,
  getCompletedBundlesService,
} from "./InventoryPageService";
import "./InventoryPage.css";
import Copyright from "../../components/Copyright/Copyright";
import {
  ArrowDownOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ArrowUpOutlined,
  EditOutlined,
  FolderOpenOutlined,
  MoreOutlined,
  ReloadOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import Header from "../../components/Header/Header";
import Loader from "../../components/Loader/Loader";
import Sidebar from "../../components/Sidebar/Sidebar";
import Cookies from "universal-cookie";
import { removeTokenFromCookies } from "../../utils/cookies";
import TextArea from "antd/es/input/TextArea";

const { Content } = Layout;

export interface InventoryPageInterface {}

const InventoryPage = (props: InventoryPageInterface) => {
  const [loading, setLoading] = useState(false);
  const [viewInventoryModal, setViewInventoryModal] = useState(false);
  const [rezeroInventoryModal, setRezeroInventoryModal] = useState(false);
  const [updateInventoryModal, setUpdateInventoryModal] = useState(false);
  const [moveFromInventoryModal, setMoveFromInventoryModal] = useState(false);
  const [moveToMetalID, setMoveToMetalID] = useState("");
  const [moveToMetalIDFormStatus, setMoveToMetalIDFormStatus] = useState("") as any;
  const [moveToMetalIDFormMessage, setMoveToMetalIDFormMessage] = useState("");
  const [inventoryMaterialData, setInventoryMaterialData] = useState({}) as any;
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [inventoryList, setInventoryList] = useState([]) as any;
  const [metals, setMetals] = useState([]);
  const [rezeroAcknowledgmentFormStatus, setRezeroAcknowledgmentFormStatus] = useState("") as any;
  const [rezeroAcknowledgmentFormMessage, setRezeroAcknowledgmentFormMessage] = useState("");
  const [updateActionFormStatus, setUpdateActionFormStatus] = useState("") as any;
  const [updateActionFormMessage, setUpdateActionFormMessage] = useState("");
  const [updateNetWeightValueFormStatus, setUpdateNetWeightValueFormStatus] = useState("") as any;
  const [updateNetWeightValueFormMessage, setUpdateNetWeightValueFormMessage] = useState("");
  const [rezeroInventoryCheckBox, setRezeroInventoryCheckBox] = useState(false);
  const [updateAction, setUpdateAction] = useState("add");
  const [updateNetWeightValue, setUpdateNetWeightValue] = useState("");
  const [notes, setNotes] = useState("");
  const [completedBundlesList, setCompletedBundlesList] = useState([]) as any;
  const highPriorityInventoryMaterialsListIDs = [
    "c18ebd12-6a31-4aa0-ad3a-3209a2065cc3", //Local Copper Mix
    "0e70ddef-6f87-4ce2-ac4d-552eb83e2722", //Local SHW
    "f1d23365-c611-4ac8-b563-1216f6456f74", //Local DHW
    "3c275ab3-a190-4f65-bac7-d0194165dc8e", //Prod Copper Mix
    "71737c5c-ae29-429e-a8d9-54e71dc67b89", //Prod SHW
    "c933dc82-15dd-4d07-994f-8c8ad904cc00", //Prod DHW
    "1ab2ea4a-e135-414d-86e3-649754590adb", //Prod Mix Wire
    "7c89c634-e33f-434a-b2d2-3e98b9dff542", //Prod Battery
  ];
  const prodCopperMixListMetalIDs: any = [
    "89f98901-7bc0-493c-992e-33fb680c46db", //A1
    "767736fb-5a87-40e4-8850-316c2d32feff", //A2
    "b9f1d4cf-8f57-419e-9c25-ab856169c103", //B Copper
    "b6693e2e-cda9-4af9-a3dd-f464090c0c0c", //Brass
    "7b42c040-003f-40d6-a850-e95b85888f9b", //E Copper
    "8b2ec3da-2fa5-4200-925c-70666914fe7a", //Nayam
  ];
  const devCopperMixListMetalIDs = [
    "120a439b-0181-4dca-ab03-bb2b5315998d", //E Copper
    "33317c60-3b59-4cc6-bcfb-60749a1510e1", //Nayam
    "4da4d002-dd41-4a5d-a800-85aba324b310", //A2
    "52f6e582-2aaf-440b-b932-4870ab98c870", //B Copper
    "58c4af3c-deef-4df2-a557-655cd0403cda", //A1
    "cf33d5c2-5d67-4158-a763-279534836b45", //Brass
  ];
  const prodCopperMixMetalID = "d208c7da-a46e-4915-8032-1ff3b5f21bda";
  const devCopperMixMetalID = "c4b3d23e-90ac-4656-9191-d50e1b49930d";
  const cookies = new Cookies();
  const userRole = cookies.get("USER_ROLE");
  const currOffice = cookies.get("CURR_OFFICE");
  let navigate = useNavigate();

  const inventoryColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Material Name",
      key: "materialName",
      align: "left" as const,
      render: (record: any) => {
        // const metalRecord: any = metals.find((metal: any) => record.metalID === metal.metalID);
        return record.displayName !== undefined ? record.displayName : "";
      },
    },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      align: "center" as const,
      render: (record: any) => Number(record.netWeight).toFixed(2),
    },
    {
      title: "Last Updated Date",
      key: "lastUpdatedDate",
      align: "center" as const,
      render: (record: any) =>
        record.updatedTimestamp
          ? `${new Date(record.updatedTimestamp).toLocaleDateString("en-GB")} ${new Date(
              record.updatedTimestamp
            ).toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            })}`
          : null,
    },
    {
      title: "Options",
      key: "options",
      align: "center" as const,
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        items.push({ key: "view", label: "View Inventory", icon: <FolderOpenOutlined /> });
        items.push({ key: "rezero", label: "Rezero Inventory", icon: <ReloadOutlined /> });
        items.push({ key: "update", label: "Update Inventory", icon: <EditOutlined /> });
        items.push({ key: "move", label: "Move Inventory", icon: <SwapOutlined /> });
        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "view") viewInventory(record);
                else if (key === "rezero") rezeroInventory(record);
                else if (key === "update") updateInventory(record);
                else if (key === "move") moveFromInventory(record);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const inventoryHistoryColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Date",
      key: "date",
      align: "center" as const,
      render: (record: any) => new Date(record.timestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Time",
      key: "time",
      align: "center" as const,
      render: (record: any) =>
        new Date(record.timestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Current Inv Net Weight",
      key: "currInventoryNetWeight",
      align: "center" as const,
      render: (record: any) => Number(record.currInventoryNetWeight).toFixed(1),
    },
    {
      title: "Action",
      key: "action",
      align: "center" as const,
      render: (record: any) => record.action,
    },
    {
      title: "Change Net Weight",
      key: "changeNetWeight",
      align: "center" as const,
      render: (record: any) => Number(record.changeInNetWeight).toFixed(1),
    },
    {
      title: "New Inv Net Weight",
      key: "newInventoryNetWeight",
      align: "center" as const,
      render: (record: any) => {
        let newInventoryNetWeight = "0.0";
        switch (record.type) {
          case "add":
            return (newInventoryNetWeight = (
              Number(record.currInventoryNetWeight) + Number(record.changeInNetWeight)
            ).toFixed(1));
          case "remove":
            return (newInventoryNetWeight = (
              Number(record.currInventoryNetWeight) - Number(record.changeInNetWeight)
            ).toFixed(1));
          case "rezero":
            return "0.0";
          default:
            return null;
        }
      },
    },
    {
      title: "Notes",
      key: "notes",
      align: "center" as const,
      render: (record: any) => {
        if (record.notes === undefined || record.notes === null) return "";
        return record.notes;
      },
    },
    {
      title: "Updated by User",
      key: "updatedByUserID",
      align: "center" as const,
      render: (record: any) => record.updatedByUserID,
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    getMetals();
  }, []);

  useEffect(() => {
    getInventory();
    getCompletedBundles();
  }, [metals]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getInventory = async () => {
    try {
      setLoading(true);
      const res = await getInventoryService(currOffice);
      const invList = res.data.map((inv: any) => {
        if (metals.length > 0) {
          const metalRecord: any = metals.find((metal: any) => inv.metalID === metal.metalID);
          inv.displayName = metalRecord.displayName;
        }
        inv.key = inv.inventoryID;
        return inv;
      });
      if (metals.length > 0) invList.sort((a: any, b: any) => a.displayName.localeCompare(b.displayName));
      setInventoryList(invList);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getInventory error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getCompletedBundles = async () => {
    try {
      setLoading(true);
      const res = await getCompletedBundlesService();
      const bundleList = res.data.map((bundle: any) => {
        if (metals.length > 0) {
          const metalRecord: any = metals.find((metal: any) => bundle.metalID === metal.metalID);
          bundle.displayName = metalRecord.displayName;
        }
        bundle.key = bundle.materialID;
        return bundle;
      });
      setCompletedBundlesList(bundleList);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getCompletedBundles error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const navToLoginPage = () => {
    navigate("/login");
  };

  const viewInventory = (record: any) => {
    setViewInventoryModal(true);
    setInventoryMaterialData(record);
  };

  const closeViewInventoryModal = () => {
    setViewInventoryModal(false);
    setInventoryMaterialData({});
    setNotes("");
  };

  const rezeroInventory = (record: any) => {
    setRezeroInventoryModal(true);
    setInventoryMaterialData(record);
  };

  const closeRezeroInventory = () => {
    setInventoryMaterialData({});
    setRezeroInventoryCheckBox(false);
    setRezeroInventoryModal(false);
    setRezeroAcknowledgmentFormStatus("");
    setRezeroAcknowledgmentFormMessage("");
    setNotes("");
  };

  const confirmRezeroInventory = async () => {
    try {
      setLoading(true);
      const payload = {
        inventoryID: inventoryMaterialData.inventoryID,
        metalID: inventoryMaterialData.metalID,
        office: inventoryMaterialData.office,
        notes: notes,
      };
      console.log("payload", payload);
      await putRezeroInventoryService(payload);
      setRezeroInventoryCheckBox(false);
      setRezeroInventoryModal(false);
      setInventoryMaterialData({});
      setNotes("");
      setLoading(false);
      await getInventory();
    } catch (e: any) {
      setLoading(false);
      console.error("confirmRezeroInventory error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const updateRezeroInventoryCheckBox = (e: any) => {
    setRezeroAcknowledgmentFormStatus("");
    setRezeroAcknowledgmentFormMessage("");
    setRezeroInventoryCheckBox(e.target.checked);
  };

  const validateRezeroInventory = () => {
    const validationStatus = rezeroInventoryCheckBox === false ? false : true;
    if (!validationStatus) {
      setRezeroAcknowledgmentFormStatus("error");
      setRezeroAcknowledgmentFormMessage("Please acknowledge that inventory will become zero");
    }
    return validationStatus;
  };

  const updateInventory = (record: any) => {
    setUpdateInventoryModal(true);
    setInventoryMaterialData(record);
  };

  const validateUpdateInventory = () => {
    let validationStatus = true;
    if (updateAction === "") {
      setUpdateActionFormStatus("error");
      setUpdateActionFormMessage("Choose an action");
      validationStatus = false;
    }
    if (Number(updateNetWeightValue) <= 0.0) {
      setUpdateNetWeightValueFormStatus("error");
      setUpdateNetWeightValueFormMessage("Weight has to be more than 0.0");
      validationStatus = false;
    }
    return validationStatus;
  };

  const confirmUpdateInventory = async () => {
    try {
      setLoading(true);
      const payload = {
        action: updateAction,
        netWeight: updateNetWeightValue,
        inventoryID: inventoryMaterialData.inventoryID,
        metalID: inventoryMaterialData.metalID,
        office: inventoryMaterialData.office,
        notes: notes,
      };
      console.log("payload", payload);
      await putUpdateInventoryService(payload);
      setUpdateAction("add");
      setUpdateNetWeightValue("");
      setUpdateInventoryModal(false);
      setInventoryMaterialData({});
      setNotes("");
      setLoading(false);
      await getInventory();
    } catch (e: any) {
      setLoading(false);
      console.error("confirmUpdateInventory error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const closeUpdateInventory = () => {
    setUpdateAction("add");
    setUpdateActionFormStatus("");
    setUpdateActionFormMessage("");
    setUpdateNetWeightValue("");
    setUpdateNetWeightValueFormStatus("");
    setUpdateNetWeightValueFormMessage("");
    setUpdateInventoryModal(false);
    setInventoryMaterialData({});
    setNotes("");
  };

  const getHighPriorityInventoryMaterials = () => {
    const copperMixMetalID = process.env.REACT_APP_ENV === "dev" ? devCopperMixMetalID : prodCopperMixMetalID;
    const copperMixListMetalIDs =
      process.env.REACT_APP_ENV === "dev" ? devCopperMixListMetalIDs : prodCopperMixListMetalIDs;
    let highPriorityMaterialCards = inventoryList
      .filter((material: any) => highPriorityInventoryMaterialsListIDs.includes(material.inventoryID))
      .map((material: any) => {
        let copperMixCardInfo = null;
        if (material.metalID === copperMixMetalID) {
          copperMixCardInfo = copperMixListMetalIDs.map((copperMixMetalID: string) => {
            const copperMixMetalInfo = inventoryList.find((material: any) => material.metalID === copperMixMetalID);
            return (
              <Col span={12}>
                <Row>
                  <Col span={12}>{copperMixMetalInfo.displayName}</Col>
                  <Col span={12}>
                    <Row justify="center">{Number(copperMixMetalInfo.netWeight).toFixed(1)} kg</Row>
                  </Col>
                </Row>
              </Col>
            );
          });
        }
        return (
          <Col span={7}>
            <Card
              title={
                <Row>
                  <Col span={12}>
                    <Row justify="center">{material.displayName}</Row>
                  </Col>
                  <Col span={12}>
                    <Row justify="center">{Number(material.netWeight).toFixed(1)} kg</Row>
                  </Col>
                </Row>
              }
              size="small"
              headStyle={{ textAlign: "center" }}
              style={{ marginBottom: "20px", padding: "10px" }}
            >
              <Row justify="start">
                Last Updated:{" "}
                {`${new Date(material.updatedTimestamp).toLocaleDateString("en-GB")} ${new Date(
                  material.updatedTimestamp
                ).toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })}`}
              </Row>
              <Row style={{ marginTop: "10px" }}>{copperMixCardInfo}</Row>
            </Card>
          </Col>
        );
      });
    highPriorityMaterialCards.unshift(
      <Col span={7}>
        <Card
          title={`Bundles ( ${completedBundlesList.length} )`}
          size="small"
          headStyle={{ textAlign: "center" }}
          style={{ marginBottom: "20px", padding: "10px" }}
        >
          {completedBundlesList.map((bundle: any) => (
            <Row>
              <Col span={12}>
                <Row justify="center"> {bundle.displayName}</Row>
              </Col>
              <Col span={12}>
                <Row justify="center">{bundle.netWeight} kg</Row>
              </Col>
            </Row>
          ))}
        </Card>
      </Col>
    );
    return highPriorityMaterialCards;
  };

  const moveFromInventory = (record: any) => {
    setMoveFromInventoryModal(true);
    setInventoryMaterialData(record);
  };

  const validateMoveFromInventory = () => {
    let validationStatus = true;
    if (moveToMetalID === "") {
      setMoveToMetalIDFormStatus("error");
      setMoveToMetalIDFormMessage("Select a material to move weight to");
      validationStatus = false;
    }
    if (Number(updateNetWeightValue) <= 0.0) {
      setUpdateNetWeightValueFormStatus("error");
      setUpdateNetWeightValueFormMessage("Weight has to be more than 0.0");
      validationStatus = false;
    }
    return validationStatus;
  };

  const confirmMoveFromInventory = async () => {
    try {
      setLoading(true);
      const payload = {
        fromMetalID: inventoryMaterialData.metalID,
        ToMetalID: moveToMetalID,
        office: inventoryMaterialData.office,
        netWeight: updateNetWeightValue,
        notes: notes,
      };
      console.log("payload", payload);
      await putMoveInventoryService(payload);
      setMoveToMetalID("");
      setUpdateNetWeightValue("");
      setMoveFromInventoryModal(false);
      setInventoryMaterialData({});
      setNotes("");
      setLoading(false);
      await getInventory();
    } catch (e: any) {
      setLoading(false);
      console.error("confirmMoveFromInventory error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const closeMoveFromInventory = () => {
    setUpdateNetWeightValue("");
    setUpdateNetWeightValueFormStatus("");
    setUpdateNetWeightValueFormMessage("");
    setMoveToMetalID("");
    setMoveToMetalIDFormStatus("");
    setMoveToMetalIDFormMessage("");
    setMoveFromInventoryModal(false);
    setInventoryMaterialData({});
    setNotes("");
  };

  const generateMaterialsList = (invMetalData: any) => {
    const sortedAllMaterialsListDropdown = metals.map((metal: any) => {
      return {
        label: metal.displayName,
        value: metal.metalID,
        disabled: metal.metalID === invMetalData.metalID,
      };
    });
    return sortedAllMaterialsListDropdown;
  };

  const updateNotes = (text: string) => {
    setNotes(text);
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row justify="start">
              <Col span={12}>
                <h2 className="purchases-title">Inventory</h2>
              </Col>
              <Col span={12}>
                <Row justify="end">
                  <Button
                    type="default"
                    onClick={() => getInventory()}
                    icon={<ReloadOutlined />}
                    style={{ marginTop: "20px" }}
                  >
                    Reload Data
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Row justify="center">
              <Col span={24}>
                <Row justify="space-between">{getHighPriorityInventoryMaterials()}</Row>
              </Col>
            </Row>
            <Row style={{ overflowY: "auto", height: "80vh" }}>
              <Table
                className="inventory-table"
                dataSource={[...inventoryList]}
                columns={inventoryColumns}
                pagination={false}
                sticky
              />
            </Row>
          </Col>
        </Row>
        <Modal
          title={`View ${inventoryMaterialData.displayName} Inventory History`}
          open={viewInventoryModal}
          okText="Close"
          onCancel={closeViewInventoryModal}
          cancelButtonProps={{ style: { display: "none" } }}
          onOk={closeViewInventoryModal}
          closable
          width={"50%"}
        >
          <p>
            Current Net Weight: <strong>{Number(inventoryMaterialData.netWeight).toFixed(1)} kg</strong>
          </p>
          <p>
            Last Updated: {new Date(inventoryMaterialData.updatedTimestamp).toLocaleDateString("en-GB")} at{" "}
            {new Date(inventoryMaterialData.updatedTimestamp).toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            })}
          </p>
          <Table
            dataSource={[...(inventoryMaterialData.updates || [])]}
            columns={inventoryHistoryColumns}
            pagination={false}
          />
        </Modal>
        <Modal
          title={`Re Zero ${inventoryMaterialData.displayName} Inventory`}
          open={rezeroInventoryModal}
          okText="Re Zero"
          onCancel={closeRezeroInventory}
          onOk={() => {
            validateRezeroInventory() && confirmRezeroInventory();
          }}
          closable
          width={"50%"}
        >
          <p>
            Current Net Weight: <strong>{Number(inventoryMaterialData.netWeight).toFixed(1)} kg</strong>
          </p>
          <p>
            Last Updated: {new Date(inventoryMaterialData.updatedTimestamp).toLocaleDateString("en-GB")} at{" "}
            {new Date(inventoryMaterialData.updatedTimestamp).toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            })}
          </p>
          Notes:
          <TextArea
            showCount
            style={{ height: 50 }}
            onChange={(e) => updateNotes(e.target.value)}
            placeholder="Enter notes"
            value={notes}
          />
          <Form layout="vertical">
            <Form.Item
              label={<label className="material-form-label"></label>}
              validateStatus={rezeroAcknowledgmentFormStatus}
              help={rezeroAcknowledgmentFormMessage}
            >
              <Checkbox onChange={updateRezeroInventoryCheckBox} checked={rezeroInventoryCheckBox}>
                I acknowledge that this action will rezero the inventory for {inventoryMaterialData.displayName}
              </Checkbox>
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title={`Update ${inventoryMaterialData.displayName} Inventory`}
          open={updateInventoryModal}
          okText="Confirm"
          onCancel={closeUpdateInventory}
          onOk={() => {
            validateUpdateInventory() && confirmUpdateInventory();
          }}
          closable
          width={"50%"}
        >
          <p>
            Current Net Weight: <strong>{Number(inventoryMaterialData.netWeight).toFixed(1)} kg</strong>
          </p>
          <p>
            Last Updated: {new Date(inventoryMaterialData.updatedTimestamp).toLocaleDateString("en-GB")} at{" "}
            {new Date(inventoryMaterialData.updatedTimestamp).toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            })}
          </p>
          <Form>
            <Form.Item
              label={<label className="material-form-label">Action</label>}
              validateStatus={updateActionFormStatus}
              help={updateActionFormMessage}
            >
              <Select
                value={updateAction}
                options={[
                  { value: "add", label: "+ Add Weight" },
                  { value: "remove", label: "- Remove Weight" },
                  { value: "update", label: "Update Weight" },
                ]}
                onChange={(e: any) => setUpdateAction(e)}
              />
            </Form.Item>
            <Form.Item
              label={<label className="material-form-label">Weight (kg)</label>}
              validateStatus={updateNetWeightValueFormStatus}
              help={updateNetWeightValueFormMessage}
            >
              <Input
                placeholder="Net Weight (kg)"
                onChange={(e: any) => {
                  setUpdateNetWeightValueFormStatus("");
                  setUpdateNetWeightValueFormMessage("");
                  setUpdateNetWeightValue(e.target.value);
                }}
                value={updateNetWeightValue}
              />
            </Form.Item>
            <Form.Item
              label={<label className="material-form-label">Notes</label>}
              validateStatus={updateNetWeightValueFormStatus}
              help={updateNetWeightValueFormMessage}
            >
              <TextArea
                showCount
                style={{ height: 50 }}
                onChange={(e) => updateNotes(e.target.value)}
                placeholder="Enter notes"
                value={notes}
              />
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title={`Move From ${inventoryMaterialData.displayName} Inventory`}
          open={moveFromInventoryModal}
          okText="Confirm"
          onCancel={closeMoveFromInventory}
          onOk={() => {
            validateMoveFromInventory() && confirmMoveFromInventory();
          }}
          closable
          width={"50%"}
        >
          <p>
            Current Net Weight: <strong>{Number(inventoryMaterialData.netWeight).toFixed(1)} kg</strong>
          </p>
          <p>
            Last Updated: {new Date(inventoryMaterialData.updatedTimestamp).toLocaleDateString("en-GB")} at{" "}
            {new Date(inventoryMaterialData.updatedTimestamp).toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            })}
          </p>
          <Form layout="vertical" style={{ marginLeft: "20px" }}>
            <Row style={{ marginBottom: "10px" }}>
              <Col span={10}>
                <label className="material-form-label">Move From</label> <ArrowUpOutlined />
              </Col>
              <Col>
                <label className="material-form-label">Move To</label> <ArrowDownOutlined />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{inventoryMaterialData.displayName}</Col>
              <Col span={4}>
                <ArrowRightOutlined />
              </Col>
              <Col span={6}>
                <Form.Item label={null} validateStatus={moveToMetalIDFormStatus} help={moveToMetalIDFormMessage}>
                  <Select
                    showSearch
                    placeholder="Select a material"
                    optionFilterProp="children"
                    value={moveToMetalID}
                    style={{ width: "200px" }}
                    onChange={(e: any) => {
                      setMoveToMetalIDFormStatus("");
                      setMoveToMetalIDFormMessage("");
                      setMoveToMetalID(e);
                    }}
                    filterOption={(input: string, option?: { label: string; value: string }) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    options={generateMaterialsList(inventoryMaterialData)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Form.Item
                label={<label className="material-form-label">Weight (kg)</label>}
                validateStatus={updateNetWeightValueFormStatus}
                help={updateNetWeightValueFormMessage}
              >
                <Input
                  placeholder="Net Weight (kg)"
                  onChange={(e: any) => {
                    setUpdateNetWeightValueFormStatus("");
                    setUpdateNetWeightValueFormMessage("");
                    setUpdateNetWeightValue(e.target.value);
                  }}
                  value={updateNetWeightValue}
                  style={{ width: "200px" }}
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                label={<label className="material-form-label">Notes</label>}
                validateStatus={updateNetWeightValueFormStatus}
                help={updateNetWeightValueFormMessage}
                style={{ width: "100%" }}
              >
                <TextArea
                  showCount
                  onChange={(e) => updateNotes(e.target.value)}
                  placeholder="Enter notes"
                  value={notes}
                />
              </Form.Item>
            </Row>
          </Form>
        </Modal>
        <Copyright />
      </Content>
    </Layout>
  );
};

export default InventoryPage;
